import Colors from 'enums/Colors';
import styled from 'styled-components';

const ReportsStyled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        gap: 2rem;
        margin-left: 180px;
        margin-top: 60px;
    `,

    Title: styled.h1`
        font-size: 32px;
        font-weight: 700;
        color: ${Colors.Blue};
    `
};

export default ReportsStyled;
